import { render } from "./VpnSettings.vue?vue&type=template&id=fee8bac8"
import script from "./VpnSettings.vue?vue&type=script&lang=js"
export * from "./VpnSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__